import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import {DefaultLanguage} from '@/locale'

const appModule = {
  namespaced: true,
  state: {
    isLoading: false,
    isInitialized: false,
    locale: DefaultLanguage,
    lastPath: null,
    apiVersion: 0
  },
  getters,
  actions,
  mutations
}

export default appModule
